import PropTypes from 'prop-types'
import { Chip } from '@mui/material'
import { ReactComponent as WarningFill } from '../../../assets/icons/warning-fill.svg'
import { ReactComponent as SuccessFill } from '../../../assets/icons/success.svg'

const StatusChip = ({ size = 'small', hasIncident, quantity }) => {
  return (
    <Chip
      icon={
        hasIncident ? (
          <WarningFill style={{ width: 20, color: 'red' }} />
        ) : (
          <SuccessFill style={{ width: 20, color: 'green' }} />
        )
      }
      size={size}
      classes={{
        root: hasIncident ? 'red' : 'green',
      }}
      label={quantity}
    />
  )
}

StatusChip.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  hasIncident: PropTypes.bool,
  quantity: PropTypes.number,
}

export default StatusChip
